/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import moment from 'moment';

// Constants
import { LONG_HUMAN_DATE_FORMAT, SHORT_HUMAN_DATE_FORMAT } from 'constants';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';

// Components
export default function ShortDate({ date, format, tooltipFormat, ...passed }) {
  const title = moment(date).format(tooltipFormat || LONG_HUMAN_DATE_FORMAT);
  const time = moment(date).format(format || SHORT_HUMAN_DATE_FORMAT);

  if (!date) return null;

  return (
    <Tooltip className="date-tooltip-wrapper" title={title} {...passed}>{time}</Tooltip>
  );
}
